import React, { useEffect } from "react";
import "../../../assets/css/reservation.css";
import Hero from "../../structures/Hero";
import { usePageMeta } from "../../../hooks/usePageMeta";
import { useNavigate } from "react-router-dom";
import { useExperiences } from "../../../hooks/useExperiences";
import Footer from "../../structures/Footer";

const Mantos = () => {
  usePageMeta({
    title: "À L'AISE Mantos Event",
  });

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const navigate = useNavigate();
  const { experiences, loading, getExp } = useExperiences();

  const handleBook = (experience) => {
    localStorage.setItem("selectedExperience", JSON.stringify(experience));
    navigate("/mantos/booking", { state: experience });
  };

  const checkAvailability = (exp) => {
    if (!exp) return { disabled: false, text: "Pesan Sekarang" };
    if (!exp.isActive) return { disabled: true, text: "Sedang Tidak Tersedia" };

    return { disabled: false, text: `Pesan ${exp.name}` };
  };

  const renderDynamicContent = (expId, fallbackDesc, fallbackIncludes = [], fallbackPrice = 200000, fallbackDuration = null) => {
    const exp = getExp(expId);
    const description = exp?.description || fallbackDesc;
    const includes = exp?.includes?.length > 0 ? exp.includes : fallbackIncludes;
    const price = exp?.price || fallbackPrice;

    return (
      <>
        <div className="experience-meta">
          <div className="meta-item">
            <span className="meta-label">HARGA</span>
            <span className="meta-value">
              {fmtPrice(price)} / orang
            </span>
          </div>
          <div className="meta-divider"></div>
          <div className="meta-item">
            <span className="meta-label">DURASI</span>
            <span className="meta-value">{exp?.duration || fallbackDuration || '1 JAM'}</span>
          </div>
          {exp?.metaFields?.map((mf, i) => (
            <React.Fragment key={i}>
              <div className="meta-divider"></div>
              <div className="meta-item">
                <span className="meta-label">{mf.label}</span>
                <span className="meta-value">{mf.value}</span>
              </div>
            </React.Fragment>
          ))}
        </div>

        <p className="experience-description">
          {description}
        </p>

        {includes?.length > 0 && (
          <div className="experience-includes">
            <h4 className="includes-title">PAKET TERMASUK</h4>
            <div className="includes-grid">
              {includes.map((item, idx) => (
                <div className="include-item" key={idx}>
                  <span className="include-icon">✓</span>
                  <span className="include-text">{item}</span>
                </div>
              ))}
            </div>
          </div>
        )}

        {(expId.includes('pottery') || expId.includes('painting') || expId.includes('combo')) && (
          <div className="experience-pottery-notes">
            <h5 className="notes-title">Catatan Kelas Pottery & Painting</h5>
            <ol className="notes-list">
                <li className="notes-item">
                <span className="notes-num">01</span>
                <p className="notes-text">Mohon datang tepat waktu sesuai jadwal booking karena terdapat sesi booking berikutnya. Keterlambatan lebih dari 10 menit akan menyebabkan booking hangus.</p>
              </li>
              <li className="notes-item">
                <span className="notes-num">02</span>
                <p className="notes-text">Booking dianggap terkonfirmasi setelah melakukan pembayaran.</p>
              </li>
              <li className="notes-item">
                <span className="notes-num">03</span>
                <p className="notes-text">Pembayaran yang sudah dilakukan tidak dapat di-refund. Apabila ingin melakukan reschedule, mohon menghubungi admin maksimal H-1 sebelum jadwal aktivitas.</p>
              </li>
              <li className="notes-item">
                <span className="notes-num">04</span>
                <p className="notes-text">Hasil pottery dapat diambil setelah mendapatkan konfirmasi dari kami bahwa karya sudah selesai. Untuk painting, hasil karya dapat langsung dibawa pulang.</p>
              </li>
              <li className="notes-item">
                <span className="notes-num">05</span>
                <p className="notes-text">Pengambilan karya maksimal 2 bulan setelah kelas berlangsung. Lewat dari batas waktu tersebut, karya bukan lagi menjadi tanggung jawab kami.</p>
              </li>
              <li className="notes-item">
                <span className="notes-num">06</span>
                <p className="notes-text">Setelah pembayaran berhasil, invoice akan dikirimkan secara otomatis ke nomor WhatsApp Anda. Mohon pastikan Anda memasukkan nomor WhatsApp yang aktif saat mengisi form booking.</p>
              </li>
            </ol>
          </div>
        )}
      </>
    );
  };

  const fmtPrice = (p) => {
    if (!p) return "—";
    if (p >= 1000000) return `Rp ${(p / 1000000).toFixed(1).replace('.0', '')} Juta`;
    if (p >= 1000) return `Rp ${(p / 1000).toLocaleString('id-ID')}K`;
    return `Rp ${p.toLocaleString('id-ID')}`;
  };

  useEffect(() => {
    const animateElements = document.querySelectorAll('.animate-on-scroll, .animate-left, .animate-right, .animate-up, .animate-scale');

    const scrollObserver = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('animate');
          scrollObserver.unobserve(entry.target);
        }
      });
    }, {
      root: null,
      rootMargin: '0px 0px -100px 0px',
      threshold: 0.1
    });

    animateElements.forEach(element => {
      scrollObserver.observe(element);
    });

    const images = document.querySelectorAll('img');
    const imageObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry, index) => {
        if (entry.isIntersecting) {
          const img = entry.target;
          setTimeout(() => {
            if (img.complete && img.naturalHeight !== 0) {
              img.classList.add('loaded');
            } else {
              img.addEventListener('load', () => {
                img.classList.add('loaded');
              }, { once: true });
            }
          }, index * 100);
          imageObserver.unobserve(img);
        }
      });
    }, {
      rootMargin: '150px',
      threshold: 0.1
    });

    images.forEach(img => {
      if (img.loading === 'lazy') {
        imageObserver.observe(img);
      }
    });

    return () => {
      scrollObserver.disconnect();
      imageObserver.disconnect();
    };
  }, [loading, experiences]);

  return (
    <div className="reservation-page-container">
      <Hero
        useSlideshow={true}
        images={[
          '/images/section6ahome_pottery1.webp',
          '/images/section7ahome_painting2.webp',
          '/images/sailing/sailing1.webp'
        ]}
      />

      <section className="reservation-intro-section animate-on-scroll">
        <div className="intro-ornament top">◆</div>
        <div className="reservation-intro-content">
          <h2 className="intro-title animate-up">EVENT MANTOS</h2>
          <div className="intro-divider"></div>
          <p className="intro-description animate-up">
            Selamat datang di event spesial Mantos. Nikmati pengalaman kreatif dengan berbagai pilihan pottery dan painting yang telah kami persiapkan khusus untuk Anda.
          </p>
        </div>
        <div className="intro-ornament bottom">◆</div>
      </section>

      <section className="experience-section pottery-section animate-on-scroll">
        <div className="experience-container">
          <div className="experience-content animate-left">
            <div className="experience-header">
              <h3 className="experience-title">POTTERY PAINT STONEWARE</h3>
            </div>

            <div className="experience-image-wrapper animate-right">
              <div className="image-frame premium">
                <img
                  src="/images/pottery/stoneware1.webp"
                  alt="Pottery Paint Stoneware experience"
                  loading="lazy"
                  onLoad={(e) => e.target.classList.add('loaded')}
                />
                <div className="image-gradient-overlay"></div>
              </div>
              <div className="experience-badge">
                <span className="badge-icon">🎨</span>
                <span className="badge-text">Workshop Premium</span>
              </div>
            </div>

            {renderDynamicContent(
              'mantos-paint-stoneware',
              'Gabungkan seni melukis dengan pembuatan tembikar stoneware premium. Buat karya unik Anda dengan pewarnaan underglaze yang menghasilkan efek transparan memukau.',
              ['700 gram tanah liat stoneware premium', 'Peralatan lengkap', 'Pewarnaan underglaze', 'Glasir transparan', 'Food grade', 'Hasil karya dapat dibawa pulang', 'Durasi sesi 2 jam'],
              450000
            )}
            <button
              className={`experience-btn primary ${checkAvailability(getExp('mantos-paint-stoneware')).disabled ? 'disabled' : ''}`}
              disabled={checkAvailability(getExp('mantos-paint-stoneware')).disabled}
              onClick={() =>
                handleBook({
                  id: "mantos-paint-stoneware",
                  name: "Pottery Paint Stoneware",
                  price: 450000,
                  icon: "🎨🏺"
                })
              }
            >
              <span>
                {checkAvailability(getExp('mantos-paint-stoneware')).text}
              </span>
              <span className="btn-arrow">→</span>
            </button>
          </div>
        </div>
      </section>

      <section className="experience-section pottery-section animate-on-scroll">
        <div className="experience-container">
          <div className="experience-content animate-right">
            <div className="experience-header">
              <h3 className="experience-title">POTTERY STONEWARE</h3>
            </div>

            <div className="experience-image-wrapper animate-left">
              <div className="image-frame premium">
                <img
                  src="/images/pottery/stoneware2.webp"
                  alt="Pottery Stoneware experience"
                  loading="lazy"
                  onLoad={(e) => e.target.classList.add('loaded')}
                />
                <div className="image-gradient-overlay"></div>
              </div>
              <div className="experience-badge">
                <span className="badge-icon">🏺</span>
                <span className="badge-text">Workshop Premium</span>
              </div>
            </div>

            {renderDynamicContent(
              'mantos-stoneware',
              'Buat tembikar stoneware premium dengan hasil akhir glasir transparan profesional. Stoneware berkualitas tinggi yang aman untuk makanan (food-grade).',
              ['700 gram tanah liat stoneware premium', 'Peralatan lengkap', 'Pendampingan instruktur', 'Glasir transparan', 'Food grade', 'Hasil karya dapat dibawa pulang', 'Durasi sesi 2 jam'],
              250000
            )}
            <button
              className={`experience-btn primary ${checkAvailability(getExp('mantos-stoneware')).disabled ? 'disabled' : ''}`}
              disabled={checkAvailability(getExp('mantos-stoneware')).disabled}
              onClick={() =>
                handleBook({
                  id: "mantos-stoneware",
                  name: "Pottery Stoneware",
                  price: 250000,
                  icon: "🏺"
                })
              }
            >
              <span>
                {checkAvailability(getExp('mantos-stoneware')).text}
              </span>
              <span className="btn-arrow">→</span>
            </button>
          </div>
        </div>
      </section>

      <section className="experience-section painting-section animate-on-scroll">
        <div className="experience-container">
          <div className="experience-content animate-left">
            <div className="experience-header">
              <h3 className="experience-title">PAINTING EARTHEN</h3>
            </div>

            <div className="experience-image-wrapper animate-right">
              <div className="image-frame premium">
                <img
                  src="/images/section7ahome_painting2.webp"
                  alt="Painting Earthen experience"
                  loading="lazy"
                  onLoad={(e) => e.target.classList.add('loaded')}
                />
                <div className="image-gradient-overlay"></div>
              </div>
              <div className="experience-badge">
                <span className="badge-icon">🎨</span>
                <span className="badge-text">Workshop Kreatif</span>
              </div>
            </div>

            {renderDynamicContent(
              'mantos-painting-earthen',
              'Ekspresikan kreativitas Anda dengan melukis di atas tembikar tanah liat (earthenware). Dengan peralatan lengkap kami, ubah tembikar polos menjadi karya seni pribadi Anda.',
              ['Media tembikar earthenware', 'Peralatan lengkap', 'Hasil karya dapat dibawa pulang', 'Durasi sesi 2 jam'],
              150000
            )}
            <button
              className={`experience-btn primary ${checkAvailability(getExp('mantos-painting-earthen')).disabled ? 'disabled' : ''}`}
              disabled={checkAvailability(getExp('mantos-painting-earthen')).disabled}
              onClick={() =>
                handleBook({
                  id: "mantos-painting-earthen",
                  name: "Painting Earthen",
                  price: 150000,
                  icon: "🎨"
                })
              }
            >
              <span>
                {checkAvailability(getExp('mantos-painting-earthen')).text}
              </span>
              <span className="btn-arrow">→</span>
            </button>
          </div>
        </div>
      </section>

      <section className="experience-section combo-section animate-on-scroll">
        <div className="experience-container">
          <div className="experience-content animate-right">
            <div className="experience-header">
              <h3 className="experience-title">POTTERY STONEWARE PAINTING EARTHEN</h3>
            </div>

            <div className="experience-image-wrapper animate-left">
              <div className="image-frame premium">
                <img
                  src="/images/pottery/potterypainting2.webp"
                  alt="Pottery Stoneware Painting Earthen experience"
                  loading="lazy"
                  onLoad={(e) => e.target.classList.add('loaded')}
                />
                <div className="image-gradient-overlay"></div>
              </div>
              <div className="experience-badge">
                <span className="badge-icon">🎨</span>
                <span className="badge-text">Kombo Premium</span>
              </div>
            </div>

            {renderDynamicContent(
              'mantos-stoneware-painting-earthen',
              'Gabungkan dua pengalaman terbaik: buat tembikar stoneware dan lukis media terracotta earthenware dalam satu sesi.',
              ['700 gram tanah liat stoneware', '1 media terracotta untuk melukis', 'Peralatan lengkap', 'Pendampingan instruktur', 'Hasil karya dapat dibawa pulang', 'Glasir transparan untuk tembikar stoneware', 'Durasi sesi: 3 jam'],
              400000
            )}
            <button
              className={`experience-btn primary ${checkAvailability(getExp('mantos-stoneware-painting-earthen')).disabled ? 'disabled' : ''}`}
              disabled={checkAvailability(getExp('mantos-stoneware-painting-earthen')).disabled}
              onClick={() =>
                handleBook({
                  id: "mantos-stoneware-painting-earthen",
                  name: "Pottery Stoneware Painting Earthen",
                  price: 400000,
                  icon: "🏺🎨"
                })
              }
            >
              <span>
                {checkAvailability(getExp('mantos-stoneware-painting-earthen')).text}
              </span>
              <span className="btn-arrow">→</span>
            </button>
          </div>
        </div>
      </section>

      <section className="experience-section pottery-section animate-on-scroll">
        <div className="experience-container">
          <div className="experience-content animate-left">
            <div className="experience-header">
              <h3 className="experience-title">POTTERY PINCH</h3>
            </div>

            <div className="experience-image-wrapper animate-right">
              <div className="image-frame premium">
                <img
                  src="/images/pottery/potterypinch1.webp"
                  alt="Pottery Pinch experience"
                  loading="lazy"
                  onLoad={(e) => e.target.classList.add('loaded')}
                />
                <div className="image-gradient-overlay"></div>
              </div>
              <div className="experience-badge">
                <span className="badge-icon">🏺</span>
                <span className="badge-text">Workshop Mantos</span>
              </div>
            </div>

            {renderDynamicContent(
              'mantos-pinch',
              'Teknik pinch pottery dengan tangan. Bentuk tanah liat menjadi tembikar dengan teknik menggunting dan memegang (pinch) yang alami.',
              ['Tanah liat earthenware', 'Peralatan lengkap', 'Pendampingan instruktur', 'Hasil karya dapat dibawa pulang', 'Durasi sesi 2 jam'],
              200000
            )}
            <button
              className={`experience-btn primary ${checkAvailability(getExp('mantos-pinch')).disabled ? 'disabled' : ''}`}
              disabled={checkAvailability(getExp('mantos-pinch')).disabled}
              onClick={() =>
                handleBook({
                  id: "mantos-pinch",
                  name: "Pottery Pinch",
                  price: 200000,
                  icon: "🏺"
                })
              }
            >
              <span>
                {checkAvailability(getExp('mantos-pinch')).text}
              </span>
              <span className="btn-arrow">→</span>
            </button>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default Mantos;